import styled from '@emotion/styled';
import { Span } from '../core/text/Span';

export const TypeSpan = styled(Span)`
  white-space: nowrap;
  min-width: 95px;
  border: none;
`;
